<template>
  <div>
    <Buscador v-if="show_buscador" @search="get_tarjetas_fidelidad"/>
    <!-- Tabla de tarjetas fidelidad -->
    <v-data-table
        :headers="tabla.headers"
        :items="tabla.tarjetas_fidelidad"
        :options.sync="tabla.options"
        :server-items-length="tabla.count"
        :fixed-header="true"
        class="elevation-3"
        calculate-widths
        :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
    >
      <template v-slot:item="{ item }">
        <tr @click="$emit('on_click_selected', item)">
          <td>{{ item.nombre }}</td>
          <td>{{ item.ref }}</td>
          <td>{{ item.precio }} {{ $store.state.centro.centro.divisa.simbolo }}</td>
          <td>{{ item.descuento_servicios }} {{ $store.state.centro.centro.divisa.simbolo }} %</td>
          <td>{{ item.descuento_productos }} {{ $store.state.centro.centro.divisa.simbolo }} %</td>
          <td>{{ item.caducidad_meses ? item.caducidad_meses == 1 ? `${item.caducidad_meses} ${$t('mes')}` : `${item.caducidad_meses} ${$t('meses')}` : $t('Sin caducidad') }}</td>
          <td v-if="is_editable">
            <v-btn icon @click="$emit('on_click_edit', item)" color="primary" :title="$t('Editar')">
              <v-icon
              >mdi-pencil
              </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'TablaTarjetasFidelidad',
  props: {
    // Filtros para realizar la búsqueda
    selected_filters: {
      type: Object,
      default: {},
      required: true
    },
    show_buscador: {
      type: Boolean,
      default: false
    },
    is_venta: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    tabla: {
      tarjetas_fidelidad: [],
      count: 0,
      headers: [],
      filtros: {},
      options: {
        itemsPerPage: 10
      }
    },
  }),

  methods: {
    /**
     * Recupera las tarjetas fidelidad de la api
     */
    async get_tarjetas_fidelidad(search = null) {
      if(search)
        this.tabla.filtros['search'] = search
      let filtros = { ...this.tabla.filtros, ...this.selected_filters }

      const response = await this.$store.dispatch("tarjeta_fidelidad/get_tarjetas_fidelidad", {
        params: filtros
      });

      this.tabla.tarjetas_fidelidad = response.results;
      this.tabla.count = response.count;
    },
  },

  watch: {
    'tabla.options': {
      handler(value) {
        this.tabla.filtros['limit'] = value.itemsPerPage
        this.tabla.filtros['offset'] = ((value.page - 1) * value.itemsPerPage)
        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.tabla.filtros['ordering'] = `${desc}${value.sortBy[0]
              .split(".")
              .join("__")}`;
        }
        this.get_tarjetas_fidelidad()
      },
    },
  },

  computed: {
    is_editable(){
      return !this.is_venta
    }
  },

  mounted() {
    this.tabla.headers = [
      { text: this.$t("Nombre"), value: "nombre", class: "primary white--text" },
      { text: this.$t("Referencia"), value: "ref", class: "primary white--text"},
      { text: this.$t("Precio"), value: "precio", class: "primary white--text" },
      { text: this.$t("Descuento servicios"), value: "descuento_servicios", class: "primary white--text" },
      { text: this.$t("Descuento productos"), value: "descuento_productos", class: "primary white--text" },
      { text: this.$t("Caducidad"), value: "caducidad_meses", class: "primary white--text" },
      { text: "", value: "actions", class: "primary white--text", sortable: false, align: "right", width: "10px" }
    ]

    // Si no es editable (caso venta) eliminamos la columna de acciones
    if(!this.is_editable) this.tabla.headers.pop()
  },
}
</script>
